export default "__VITE_ASSET___gkemPbf__"